// extracted by mini-css-extract-plugin
export var accordion = "accordion-module--accordion--b7dd9";
export var accordionContent = "accordion-module--accordionContent--7b064";
export var accordionIcon = "accordion-module--accordionIcon--f3c5d";
export var accordionSection = "accordion-module--accordionSection--0b5e1";
export var accordionText = "accordion-module--accordionText--b59cf";
export var accordionTitle = "accordion-module--accordionTitle--c38f8";
export var active = "accordion-module--active--938a6";
export var rotate = "accordion-module--rotate--8cc23";